<template>
  <div class="slider-interface"
       :class="{ 'slider-interface--animating': animating }"
  >
    <outline-button
      class="slider-interface__button slider-interface__button--prev"
      noBorder
      iconOnly
      buttonIcon="chevron_left"
      @click="handleButtonClick('prev')"
      tabindex="1"
    />
    <div class="slider-interface__range" @touchstart.stop>
      <VueSlider
        v-model="internalValue"
        :min="0"
        :max="itemCount - 1"
        :dotSize="dotSize"
        tooltip="none"
        :height="1"
      />
    </div>
      <outline-button
      class="slider-interface__button slider-interface__button--next"
      noBorder
      iconOnly
      buttonIcon="chevron_right"
      @click="handleButtonClick('next')"
      tabindex="2"
    />
  </div>
</template>
<script>
/**
 * Slider control used for interactive can
 */
import VueSlider from 'vue-slider-component';
import SliderInterface from './../mixins/slider-interface';
import {
  SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_LARGE,
} from '../../design-tokens/build/dictionary';
import {
  getNumberFromToken
} from './../core/utils';

export default {
  name: 'slider-interface',
  mixins: [SliderInterface],
  components: {
    VueSlider
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    animating: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      dummy: 0,
      dotSize: getNumberFromToken(SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_LARGE),
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.handleInput(value);
      }
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
      if (this.animating) {
        this.$emit('stopAnimation');
      }
    },
  }
};
</script>

<style lang="scss">
@import './../assets/styles/vue-slider.scss';

.slider-interface {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $size-height-slider-interface-large;
  width: $size-width-slider-interface-large;
  margin: $size-margin-slider-interface-large;
  @include global-media(small) {
    height: $size-height-slider-interface-small;
    width: $size-width-slider-interface-small;
    margin: $size-margin-slider-interface-small;
  }
  &__button{
    height: $size-height-slider-interface-button-large;
    width: $size-width-slider-interface-button-large;
    flex: 0 0 auto;
    @include global-media(small) {
      height: $size-height-slider-interface-button-small;
      width: $size-width-slider-interface-button-small;
    }
  }
  &__range {
    flex: 1 1 auto;
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      background-color: $color-background-slider-interface-range-track;
      height: $size-height-slider-interface-range-track-large;
      width: 100%;
      @include global-media(small) {
        height: $size-height-slider-interface-range-track-small;
      }
    }
  }
  &--animating {
    .vue-slider-dot {
      transition: none !important; // overriding vue-slider defaults when can is animating
      left: 50% !important; // overriding vue-slider defaults when can is animating
    }
  }
}
</style>
